import React from 'react';
import './BbScores.css';

import { TrophyFill } from 'react-bootstrap-icons';

class Scores extends React.Component {
  componentDidMount()
  {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.scores !== this.props.scores) {
      return true;
    }
    return false;
  }

  getPreviousScore(user, cyclesPlayed)
  {
    if (cyclesPlayed === 1)
    {
      return 0;
    }
    const previousScore = this.props.previousScores !== undefined ? this.props.previousScores : [];
    for (let index = 0; index < previousScore.length; index += 1) {
      const o = previousScore[index];
      if (o.user_login === user) {
        return o.score;
      }
    }

    return 0;
  }

  reconcileScore(scoreObj, cyclesPlayed)
  {
    const previousScore = this.getPreviousScore(scoreObj.user_login, cyclesPlayed);
    const currentScore = scoreObj.score !== undefined ? scoreObj.score : 0;
    if (currentScore > previousScore)
    {
      return 'correct';
    }
    if (currentScore < previousScore)
    {
      return 'wrong';
    }
    return 'noplay';
  }

  /**
   * Append an asterisks to THIS player name in the scoreboard
   * @param {object} scoreObj
   * @returns {string} Name of css class or empty string
   */
  cssSwitcher(scoreObj)
  {
    if (this.props.playerName === scoreObj.user_login)
    {
      return 'bb-me';
    }
    return '';
  }

  render() {
    console.log('*** SCORES ***');
    const scores = this.props.scores !== undefined ? this.props.scores : [];
    const rounds = this.props.rounds !== undefined ? this.props.rounds : [];
    const roundsPlayed = parseInt(rounds.rounds_played, 10);
    const maxRounds = parseInt(rounds.max_rounds, 10);
    let winnerMsg = '';
    let scoresContent = '';

    // This big IF condition is just for TrophyFill. TrophyFill and
    // className = winnerwinner are the ONLY DIFFs between if and else.

    // IF End of Game...
    if (roundsPlayed >= maxRounds) {
      winnerMsg = ' Winner! ';
      scoresContent = scores.map((scoreObj) => (
        <li
          key={`li${scoreObj.user_login}`}
          id={scoreObj.user_login}
          className="winnerwinner text-white list-group-item bg-dark d-flex justify-content-between align-items-center px-3 py-1 mx-1 my-1 fw-bold"
        >
          <span className={this.cssSwitcher(scoreObj)}>{scoreObj.user_login}</span>
          <span className="winnerwinner">
            <TrophyFill />
            {' '}
            { winnerMsg }
          </span>
          <span className={this.reconcileScore(scoreObj, roundsPlayed)}>
            {scoreObj.score}
          </span>
        </li>
      ));
    // IF NOT End of Game...
    } else {
      scoresContent = scores.map((scoreObj) => (
        <li
          key={`li${scoreObj.user_login}`}
          id={scoreObj.user_login}
          className="text-white list-group-item bg-dark d-flex justify-content-between align-items-center px-3 py-1 mx-1 my-1 fw-bold"
        >
          <span className={this.cssSwitcher(scoreObj)}>{scoreObj.user_login}</span>
          <span className={this.reconcileScore(scoreObj, roundsPlayed)}>
            {scoreObj.score}
          </span>
        </li>
      ));
    }
    return (
      <div className="x">
        <div className="row gx-0">
          <div className="col-12 d-flex justify-content-center">
            <h4>Scoreboard</h4>
          </div>
        </div>
        <div className="row gx-0">
          <div className="col-12" style={{ width: '100%' }}>
            <ul
              key="ul-scoreboard"
              className="bb-score-list text-white list-group list-group-flush container-fluid justify-content-between shadow-sm p-0 m-0 rounded"
            >
              {scoresContent}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default Scores;
